export enum NewRelicEventTypes {
  MOBILECUSTOMEVENT = 'MobileCustomEvent',
}

export enum NewRelicEventNames {
  ATTACHMENTDOWNLOAD = 'AttachmentDownload',
  DOCUMENTDOWNLOAD = 'DocumentDownload',
  APPRESUME = 'AppResume',
  USERLOGIN = 'UserLogin',
  USERLOGOUT = 'UserLogout',
  TICKETCREATION = 'TicketCreation',
  TICKETCREATIONCANCEL = 'TicketCreationCancel',
  USERREGISTRATION = 'UserRegistration',
  USERREGISTRATIONCANCEL = 'UserRegistrationCancel',
  AI_ASSISETENT = 'AI_Assistent',
  // ART-19930: why sessions end and why devices stop receiving push. Without
  // these the field reports ("I was logged out and lost my notifications")
  // cannot be traced to a cause.
  TOKENREFRESHFAILURE = 'TokenRefreshFailure',
  PUSHREGISTRATION = 'PushRegistration',
}

export enum NewRelicMetricCategoryNames {
  FEATUREUSAGE = 'FeatureUsage',
}

export interface NewRelicAttributes {
  [key: string]: string | number | boolean | undefined;
  status?: string;
  fileName?: string;
  platform?: string;
  message?: string;
  issueType?: string;
}

export enum NewRelicInteractionNames {
  TICKETCREATION_DAMAGE = 'TicketCreation_Damage',
  TICKETCREATION_CONCERN = 'TicketCreation_Concern',
  REGISTRATION = 'Registration',
}

export enum NewRelicStatusType {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
  CANCELLED = 'CANCELLED',
  TIMEOUT = 'TIMEOUT',
  RETRY = 'RETRY',
  WRITE_ERROR = 'WRITE_ERROR',
}

export type InteractionId = string | null;
